export const IMG = {
  heroHighway: '/assets/truck1.png',
  nightStreet: '/assets/truck2.png',
  warehouse: '/assets/truck3.png',
  aerialSand: '/assets/truck4.png',
};

export const VIDEO = {
  heroHighway: "/assets/truckbg.mp4"
}

export const COMPANY = {
  name: 'Ambadykannan Transport',
  tagline: 'Reliable Truck & Lorry Transportation Across Kerala & Tamil Nadu',
  phone: '+919447713460',
  phoneHref: '+919447713460',
  whatsapp: '918078103460',
  email: 'arunknair200@gmail.com',
  address: 'Raji Nivas Coolimuttam Polpully, PO Palakkad',
  hours: 'Mon – Sun, 8AM to 10PM',
};

export const STATS = [
  { value: 16, suffix: '+', label: 'Years on the Road' },
  { value: 1000, suffix: '+', label: 'Happy Clients' },
  { value: 5000, suffix: '+', label: 'Deliveries Completed' },
  { value: 5 , suffix: '-13', label: 'Ton segments' },
];

export const SERVICES = [
  { id: 'truck-transport', title: 'Truck Transport', icon: 'GiTruck', desc: 'Multi-axle truck haulage built for heavy, high-volume consignments across state lines.' },
  { id: 'lorry-transport', title: 'Lorry Transport', icon: 'FaTruckMoving', desc: 'Flexible lorry fleet for regional runs, market loads, and scheduled distribution routes.' },
  { id: 'goods-delivery', title: 'Goods Delivery', icon: 'FaBoxes', desc: 'Doorstep and depot-to-depot goods delivery with real-time dispatch coordination.' },
  { id: 'industrial-transport', title: 'Industrial Transport', icon: 'GiFactory', desc: 'Machinery, equipment, and industrial cargo moved with load-secured precision.' },
  { id: 'construction-material', title: 'Construction Material Transport', icon: 'FaHardHat', desc: 'Cement, steel, and site material delivered on schedule to keep builds moving.' },
  // { id: 'sand-metal', title: 'Sand & Metal Transport', icon: 'GiStonePile', desc: 'Licensed sand, metal, and aggregate haulage compliant with regional transport norms.' },
  { id: 'long-distance-freight', title: 'Long Distance Freight', icon: 'FaRoute', desc: 'Cross-state freight corridors run by experienced long-haul drivers, day and night.' },
  // { id: 'commercial-logistics', title: 'Commercial Logistics', icon: 'FaWarehouse', desc: 'End-to-end logistics planning for businesses that need dependable supply chains.' },
];

export const WHY_CHOOSE_US = [
  { icon: 'FaSatelliteDish', title: 'GPS Tracking', desc: 'Every consignment tracked live from pickup to delivery.' },
  { icon: 'FaShieldAlt', title: 'Safe Delivery', desc: 'Secured loading and trained handling protect every cargo.' },
  { icon: 'FaIdCard', title: 'Experienced Drivers', desc: 'Route-hardened drivers who know Kerala & Tamil Nadu roads.' },
  { icon: 'FaRupeeSign', title: 'Affordable Pricing', desc: 'Transparent rates with no hidden charges, ever.' },
  { icon: 'FaClock', title: 'On-Time Delivery', desc: 'Dispatch schedules built around your deadlines, not ours.' },
  // { icon: 'FaFileContract', title: 'Insurance Support', desc: 'Cargo insurance assistance for complete peace of mind.' },
];

export const FLEET = [
  { title: 'Heavy Duty Trucks', img: IMG.heroHighway, spec: 'Payload up to 25T · Multi-axle · Night-run ready' },
  { title: 'Container Lorries', img: IMG.aerialSand, spec: 'Sand & aggregate haulage · Hydraulic tipping' },
  { title: 'Cargo Carriers', img: IMG.warehouse, spec: 'Depot-to-depot goods · Covered load bays' },
  { title: 'Long-Haul Fleet', img: IMG.nightStreet, spec: 'Cross-state freight · GPS-tracked routes' },
];

export const PROCESS = [
  { title: 'Pickup', desc: 'We arrive at your location and inspect the consignment.' },
  { title: 'Loading', desc: 'Cargo is secured and load-balanced by trained handlers.' },
  { title: 'Transportation', desc: 'Tracked transit across the fastest safe route.' },
  { title: 'Safe Delivery', desc: 'Consignment verified and handed over on schedule.' },
];

export const TESTIMONIALS = [
  { name: 'Suresh Kumar', role: 'Construction Contractor, Coimbatore', quote: 'Our site never waits for material anymore — deliveries land exactly when scheduled.', rating: 5 },
  { name: 'Latha Menon', role: 'Textile Exporter, Kochi', quote: 'Handling heavy freight across two states used to worry us. Not anymore.', rating: 5 },
  { name: 'Vignesh R.', role: 'Warehouse Manager, Salem', quote: 'GPS tracking alone changed how we plan our inbound stock.', rating: 5 },
  { name: 'Abdul Rahman', role: 'Sand Quarry Owner, Palakkad', quote: 'Compliant, punctual, and the drivers know every back route there is.', rating: 4 },
];
